/**
 * Traducción entre `settings.period` (snake_case, lo que persiste el informe) y el estado del
 * selector de período del Explorador (`{selectedPeriod, range}`). Puro, sin React: acá vive el
 * guardián del round-trip (C-informes-03).
 */
import moment from 'moment';

const DATE = 'YYYY-MM-DD';

/** `settings.period` (snake_case) → `initialPeriodState` del selector del Explorador. */
export function periodToSelectorState(period) {
    if (!period) return {selectedPeriod: 'LAST_30_DAYS'};
    if (period.type === 'FIXED' && period.start_date && period.end_date) {
        // `moment(str, fmt)` parsea en hora LOCAL; `new Date('YYYY-MM-DD')` parsea en UTC y en una
        // zona negativa corre el día hacia atrás en cada vuelta (C-informes-03: loop infinito).
        return {selectedPeriod: 'CUSTOM', range: {from: moment(period.start_date, DATE).toDate(), to: moment(period.end_date, DATE).toDate()}};
    }
    return {selectedPeriod: period.predefined_period || 'LAST_30_DAYS'};
}

/** Lo que emite el selector (`{selectedPeriod, range}`) → `settings.period`. */
export function selectorStateToPeriod(state) {
    if (!state || !state.selectedPeriod) return null;
    if (state.selectedPeriod === 'CUSTOM') {
        if (!state.range || !state.range.from || !state.range.to) return null;
        return {type: 'FIXED', start_date: moment(state.range.from).format(DATE), end_date: moment(state.range.to).format(DATE)};
    }
    return {type: 'RELATIVE', predefined_period: state.selectedPeriod};
}
